import React from "react";
import Error from "routes/Error";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error, hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Error
          error={this.state.error}
          isAgentPortal={this.props.isAgentPortal}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
